import React from "react";
import { Card, CardContent, Typography, IconButton, Box } from "@mui/material";
import { Delete, InsertDriveFile } from "@mui/icons-material";

const FilePreview = ({ file, onRemove }) => {
  if (!file) return null;

  const renderFileIcon = () => {
    if (file?.type?.startsWith("image/")) {
      return (
        <img
          src={URL.createObjectURL(file)}
          alt="preview"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            borderRadius: "4px",
          }}
        />
      );
    }
    return <InsertDriveFile sx={{ fontSize: 40, color: "#777" }} />;
  };

  return (
    <Card
      variant="outlined"
      sx={{
        display: "flex",
        alignItems: "center",
        p: 1.25,
        borderRadius: "24px",
        borderColor: "divider",
        backgroundColor: "background.paper",
        width: "100%",
        boxSizing: "border-box",
      }}
    >
      <Box
        sx={{
          width: 64,
          height: 64,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          // backgroundColor: "#f5f5f5",
          borderRadius: "4px",
        }}
      >
        {renderFileIcon()}
      </Box>
      <CardContent sx={{ flex: 1, paddingLeft: 2 }}>
        <Typography variant="body2">Arquivo: {file?.name}</Typography>
        <Typography variant="caption">
          Tamanho: {(file?.size / 1024).toFixed(2)} KB
        </Typography>
      </CardContent>
      <IconButton onClick={onRemove}>
        <Delete />
      </IconButton>
    </Card>
  );
};

export default FilePreview;
